import { Icon20SmileAddOutline } from '@vkontakte/icons';
import { Button, Spacing, Text, Title } from '@vkontakte/vkui';
import backgroundImageA from 'img/family-content/empty-block-background-a.png';
import backgroundImageB from 'img/family-content/empty-block-background-b.png';
import React, { type ReactElement, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { familyUpdatedEmptystateA, familyUpdatedEmptystateB } from 'reactApp/appHelpers/featuresHelpers/features/familyFunctions';
import { historyPush } from 'reactApp/modules/router/router.module';
import baseStyles from 'reactApp/ui/FamilyContentEmpty/FamilyContentEmpty.css';
import { sendDwh } from 'reactApp/utils/ga';

import styles from './FamilyContentNewEmptyCards.css';

export const FamilySubscription = (): ReactElement => {
    const dispatch = useDispatch();
    const onClick = () => {
        sendDwh({
            eventCategory: 'empty-family',
            action: 'click',
            p: 'cloud-web-analytics',
            dwh_enabled: true,
            dwhData: { name: 'add_members' },
        });
        dispatch(historyPush({ id: `/family` }));
    };

    useEffect(() => {
        sendDwh({
            eventCategory: 'empty-family',
            action: 'show',
            p: 'cloud-web-analytics',
            dwh_enabled: true,
            dwhData: { name: 'add_members' },
        });
    }, []);

    let currentBackgroundImage = backgroundImageA;
    let variantClass = '';
    if (familyUpdatedEmptystateA) {
        currentBackgroundImage = backgroundImageA;
        variantClass = styles.variantA;
    } else if (familyUpdatedEmptystateB) {
        currentBackgroundImage = backgroundImageB;
        variantClass = styles.variantB;
    }

    return (
        <div
            id="family-card-subscription"
            className={`${baseStyles.card} ${variantClass}`}
            onClick={onClick}
            data-qa-id="family-subscription"
        >
            <Title level="2" data-qa-id="family-subscription-title">
                Добавьте&nbsp;ещё&nbsp;3&nbsp;близких
            </Title>
            <Spacing size={8} style={{ pointerEvents: 'none' }} />
            <Text data-qa-id="family-subscription-content">
                У каждого — все возможности
                <br />
                тарифа и место для общих файлов
            </Text>
            <Spacing size={20} style={{ pointerEvents: 'none' }} />
            <img src={currentBackgroundImage} alt="Близкие в подписке" className={styles.image} data-qa-id="family-subscription-mascot" />
            <Button
                mode="primary"
                appearance="accent-invariable"
                size="l"
                before={<Icon20SmileAddOutline />}
                className={styles.button}
                data-qa-id="family-subscription-button"
                onClick={(e) => {
                    e.stopPropagation();
                    onClick();
                }}
            >
                Добавить
            </Button>
        </div>
    );
};
